import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { AuthService, User } from '@auth0/auth0-angular';
import {
  AnalyticsService,
  UserTypeEnum,
  UiCoreModule,
  LoadingSpinnerComponent,
  ToastContainerComponent,
} from '@bodyanalytics/ui-core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bodyanalytics-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, AsyncPipe, UiCoreModule, LoadingSpinnerComponent, ToastContainerComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Search';
  public auth = inject(AuthService);
  private router = inject(Router);
  private analyticsService = inject(AnalyticsService);
  private authSubscription: Subscription | null = null;

  ngOnInit(): void {
    // Set user type for calendar portal (operators use calendar)
    this.analyticsService.setUserType(UserTypeEnum.OPERATOR);

    // Subscribe to Auth0 user observable to track user ID
    this.authSubscription = this.auth.user$.subscribe((user: User | null | undefined) => {
      if (user && user.sub) {
        // User is authenticated, set user ID
        this.analyticsService.setUserId(user.sub);
      } else {
        // User is logged out, clear user ID
        this.analyticsService.setUserId(null);
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
